<template>
  <el-dialog
    v-dialogDrag
    :title="`${formProps.editType === 'create' ? '新增' : '编辑'}隐患信息`"
    :visible.sync="visible"
    :close-on-click-modal="false"
    class="large-dialog"
    width="1280px"
  >
    <div>
      <el-form ref="form" label-width="180px" :model="formData">
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              label="隐患描述"
              prop="hiddenDangerName"
              :rules="[
                {
                  required: true,
                  message: '请输入隐患描述',
                  trigger: ['blur', 'change'],
                },
              ]"
            >
              <el-input
                v-model="formData.hiddenDangerName"
                placeholder="请输入隐患描述"
                maxlength="500"
                type="textarea"
                :autosize="{ minRows: 4, maxRows: 6 }"
                show-word-limit
                clearable
                :disabled="formProps.editType === 'read'"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="隐患编码" prop="hiddenDangerCode">
              <el-input
                v-model="formData.hiddenDangerCode"
                placeholder="请输入隐患编码"
                maxlength="50"
                show-word-limit
                clearable
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="所在区域"
              prop="areaId"
              :rules="[
                {
                  required: true,
                  message: '请选择所在区域',
                  trigger: ['blur', 'change'],
                },
              ]"
            >
              <el-select
                v-model="formData.areaId"
                class="w-full"
                placeholder="请选择所在区域"
                clearable
                filterable
                :disabled="formProps.editType === 'read'"
              >
                <el-option
                  v-for="item in areaList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              label="隐患类别"
              :rules="[{ required: true, message: '请选择隐患类别', trigger: 'change' }]"
              prop="hiddenDangerCategory"
            >
              <el-select
                v-model="formData.hiddenDangerCategory"
                class="w-full"
                placeholder="请选择隐患类别"
                filterable
                clearable
                :disabled="formProps.editType === 'read'"
              >
                <el-option
                  v-for="item in hiddenCategoryList"
                  :key="item.code"
                  :label="item.displayName"
                  :value="Number(item.code)"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
            <el-form-item
              label="隐患类型"
              prop="hiddenDangerType"
              :rules="[
                {
                  required: true,
                  message: '请选择隐患类型',
                  trigger: ['blur', 'change'],
                },
              ]"
            >
              <el-select
                v-model="formData.hiddenDangerType"
                class="w-full"
                placeholder="请选择隐患类型"
                filterable
                clearable
                :disabled="formProps.editType === 'read'"
              >
                <el-option
                  v-for="item in hiddenTypeList"
                  :key="item.code"
                  :label="item.displayName"
                  :value="Number(item.code)"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col> -->
          <el-col :span="12">
            <el-form-item
              label="隐患来源"
              prop="hiddenDangerSource"
              :rules="[
                {
                  required: true,
                  message: '请输入隐患来源',
                  trigger: ['blur', 'change'],
                },
              ]"
            >
              <el-select
                v-model="formData.hiddenDangerSource"
                class="w-full"
                placeholder="请选择隐患来源"
                clearable
                filterable
                :disabled="formProps.editType === 'read'"
              >
                <!-- || (formProps.editType === 'create' && formData.id) -->
                <el-option
                  v-for="item in hiddenSourceList"
                  :key="item.code"
                  :label="item.displayName"
                  :value="Number(item.code)"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="隐患可能危害" prop="hiddenDangerHarm">
              <el-input
                v-model="formData.hiddenDangerHarm"
                placeholder="请输入隐患可能危害"
                maxlength="50"
                show-word-limit
                clearable
                :disabled="formProps.editType === 'read'"
              ></el-input>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
            <el-form-item label="所属系统/机组" prop="ownedSystemOrUnit">
              <el-select
                multiple
                v-model="formData.ownedSystemOrUnit"
                class="w-full"
                placeholder="请选择所属系统/机组"
                clearable
                filterable
                :disabled="formProps.editType === 'read'"
              >
                <el-option
                  v-for="item in ownedSystemOrUnitList"
                  :key="item.id"
                  :label="item.displayName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col> -->
          <el-col :span="12">
            <el-form-item
              label="隐患等级"
              prop="hiddenDangerlevel"
              :rules="[
                {
                  required: true,
                  message: '请输入隐患等级',
                  trigger: ['blur', 'change'],
                },
              ]"
            >
              <el-select
                v-model="formData.hiddenDangerlevel"
                class="w-full"
                placeholder="请选择隐患等级"
                clearable
                filterable
                :disabled="formProps.editType === 'read'"
              >
                <el-option
                  v-for="item in hiddenLevelList"
                  :key="item.code"
                  :label="item.displayName"
                  :value="Number(item.code)"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="隐患归属" prop="hiddenDangerBelong">
              <el-select
                v-model="formData.hiddenDangerBelong"
                class="w-full"
                clearable
                filterable
                :disabled="formProps.editType === 'read'"
              >
                <el-option
                  v-for="item in sectionList"
                  :key="item.code"
                  :label="item.displayName"
                  :value="item.code"
                ></el-option>
              </el-select> </el-form-item
          ></el-col>
          <el-col :span="12">
            <el-form-item
              label="安全检查标题"
              v-if="formData.hiddenDangerSource === 1"
              prop="safetyInspectionTitle"
            >
              <el-input
                v-model="formData.safetyInspectionTitle"
                placeholder="请输入安全检查标题"
                clearable
                :disabled="formProps.editType === 'read'"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="安全检查标题"
              v-else
              prop="safetyInspectionTitle"
              :rules="[
                {
                  required: true,
                  message: '请输入安全检查标题',
                  trigger: ['blur', 'change'],
                },
              ]"
            >
              <el-input
                v-model="formData.safetyInspectionTitle"
                placeholder="请输入安全检查标题"
                clearable
                :disabled="formProps.editType === 'read'"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="安全检查期数">
              <el-input
                v-model="formData.safetyInspectionPeriods"
                placeholder="请输入安全检查期数"
                clearable
                :disabled="formProps.editType === 'read'"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="建议整改措施">
              <el-input
                v-model="formData.suggestedRectificationMeasures"
                placeholder="请输入建议整改措施"
                type="textarea"
                :autosize="{ minRows: 4, maxRows: 6 }"
                clearable
                :disabled="formProps.editType === 'read'"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item
              label="整改前图片"
              prop="photosBeforeRectification"
              ref="photosBeforeRectification"
            >
              <img-upload
                v-model="formData.photosBeforeRectification"
                :upload-width="120"
                :upload-height="120"
                :maxSize="20"
                :limit="99"
                :isDisabledUploadComponent="formProps.editType === 'read'"
                :isShowDeleteButton="formProps.editType !== 'read'"
                @change="changePersonSelect('photosBeforeRectification')"
              ></img-upload>
            </el-form-item>
          </el-col>
          <template v-if="formData.isCheckCorrect">
            <el-col :span="12">
              <el-form-item
                label="隐患整改期限"
                prop="hiddenDangerRectificationPeriod"
                :rules="[
                  {
                    required: true,
                    validator: validatorDate,
                    trigger: ['blur', 'change'],
                  },
                ]"
              >
                <el-date-picker
                  size="small"
                  v-model="formData.hiddenDangerRectificationPeriod"
                  :disabled="formProps.editType === 'read'"
                  type="datetime"
                  class="!w-full"
                  placeholder="请选择隐患整改期限"
                  :picker-options="pickerOptions"
                  clearable
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="隐患整改负责人"
                prop="personChargeHiddenDangerRectificationId"
                ref="personChargeHiddenDangerRectificationId"
                :rules="[
                  {
                    required: true,
                    validator: validatorPerson,
                    trigger: ['blur', 'change'],
                  },
                ]"
              >
                <person-select
                  v-model="formData.personChargeHiddenDangerRectificationId"
                  :disabled="['read', 'refreshPublish'].includes(formProps.editType)"
                  @change="changePersonSelect('personChargeHiddenDangerRectificationId')"
                ></person-select>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item
                label="隐患验收负责人"
                prop="personChargeHiddenDangerAcceptanceId"
                :rules="[
                  {
                    required: true,
                    validator: validatorPerson,
                    message: '请输入隐患验收负责人',
                    trigger: ['blur', 'change'],
                  },
                ]"
              >
                <!-- <person-select
                  v-model="formData.personChargeHiddenDangerAcceptanceId"
                  :disabled="['read', 'refreshPublish'].includes(formProps.editType)"
                  @change="changePersonSelect('personChargeHiddenDangerAcceptanceId')"
                ></person-select> -->
                <el-select
                  :disabled="['read', 'refreshPublish'].includes(formProps.editType)"
                  v-model="formData.personChargeHiddenDangerAcceptanceId"
                  class="w-full"
                  placeholder="请选择隐患验收负责人"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="item in acceptUsers"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </template>
          <!-- <template v-else>
            <el-col :span="12">
              <el-form-item
                label="隐患核实人"
                prop="hiddenDangerVerifierPersonId"
                ref="hiddenDangerVerifierPersonId"
                :rules="[
                  {
                    required: true,
                    message: '请输入隐患核实人',
                    trigger: ['blur', 'change'],
                  },
                ]"
              >
                <person-select
                  v-model="formData.hiddenDangerVerifierPersonId"
                  :disabled="['read', 'refreshPublish'].includes(formProps.editType)"
                  @change="changePersonSelect('hiddenDangerVerifierPersonId')"
                ></person-select>
              </el-form-item>
            </el-col>
          </template> -->
        </el-row>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer" v-if="formProps.editType !== 'read'">
      <div class="flex justify-center">
        <el-button type="primary" size="small" @click="submitForm('submit')" :loading="loading"
          >提交</el-button
        >
        <el-button type="primary" size="small" @click="submitForm" :loading="loading"
          >保存</el-button
        >
        <el-button @click="cancel" size="small">取消</el-button>
      </div>
    </div>
    <SelecWorkFlowtUser
      v-if="selectUserVisible"
      :isMultiple="true"
      nodeName="隐患一级审批"
      formLabel="隐患审核人"
      type="hiddenList"
      :dataId="currentSubmitRes.id"
      :visible.sync="selectUserVisible"
      @selected="saveUserToApprove"
      @close="closeUserToApprove"
    ></SelecWorkFlowtUser>
  </el-dialog>
</template>

<script>
import dayjs from 'dayjs'
import { HiddenDangerRectificationChecklistApi } from '@wiz-api/double-prevention-management'
import { AreaApi } from '@wiz-api/area-management'
import utils from '@/components/safety/enumField/utils'
import PersonSelect from '@/components/safety/FormSelect/PersonSelect'
import ImgUpload from '@/components/safety/ImgUpload/ImgUpload'
import PointSelect from '../PointSelect/PointSelect'

const SelecWorkFlowtUser = () => {
  return import('../HiddenVerify/SelecWorkFlowtUser')
}
const areaApi = new AreaApi()

const hiddenDangerRectificationChecklistApi = new HiddenDangerRectificationChecklistApi()
export default {
  name: 'hidden-list-form',
  components: {
    PersonSelect,
    ImgUpload,
    SelecWorkFlowtUser,
  },
  props: {
    FormData: {
      type: Object,
      default: () => {},
    },
    formProps: {
      type: Object,
      default: () => {
        return {
          // create 新增 update 编辑 read 详情
          editType: 'create',
        }
      },
    },
  },
  data() {
    return {
      selectUserVisible: false,
      currentSubmitRes: {},
      areaList: [],
      hiddenCategoryList: [],
      hiddenTypeList: [],
      hiddenLevelList: [],
      hiddenSourceList: [],
      ownedSystemOrUnitList: [],
      checkTypeList: [],
      pickerOptions: {
        disabledDate(v) {
          return dayjs(v).format('YYYY-MM-DD') < dayjs().format('YYYY-MM-DD')
        },
      },
      formData: {
        isCheckCorrect: false,
      },
      visible: true,
      datePickerValue: [],
      searchData: {
        type: '',
        readStatus: '',
        title: '',
      },
      loading: false,
      troubleshootingResultList: [],
      troubleshootingStatusList: [],
      acceptUsers: [],
      isSelect: false,
      sectionList: [],
    }
  },
  computed: {},
  watch: {
    datePickerValue(list) {
      this.searchData.startTime = list && list.length ? list[0] : ''
      this.searchData.endTime = list && list.length ? list[1] : ''
    },
    visible(val) {
      if (!val) {
        this.$emit('cancel')
      }
    },
  },
  created() {
    this.getData()
    this.getAcceptUsers()
    this.getAreaList()
    utils.getDataCategory(
      [
        'DoublePreventionManagement.DataCategory.CheckType',
        'DoublePreventionManagement.DataCategory.HiddenSource',
        'DoublePreventionManagement.DataCategory.HiddenLevel',
        'DoublePreventionManagement.DataCategory.HiddenType',
        'DoublePreventionManagement.DataCategory.HiddenCategory',
        'DoublePreventionManagement.DataCategory.OwnedSystemOrUnit',
        'DoublePreventionManagement.DataCategory.HiddenDangerBelong',
      ],
      [
        'checkTypeList',
        'hiddenSourceList',
        'hiddenLevelList',
        'hiddenTypeList',
        'hiddenCategoryList',
        'ownedSystemOrUnitList',
        'sectionList',
      ],
      this
    )
  },
  methods: {
    closeUserToApprove() {
      this.$emit('refreshList')
      this.$emit('cancel')
    },
    async saveUserToApprove(ids) {
      const [
        submiterr,
        submitres,
      ] = await hiddenDangerRectificationChecklistApi.hiddenDangersReporteSubmit({
        body: {
          id: this.currentSubmitRes.id,
          receiverIds: ids,
        },
      })
      if (!submiterr) {
        this.$message({
          showClose: true,
          message: '提交成功',
          type: 'success',
        })
        this.currentSubmitRes = {}
        // 待办新增过来回待办
        if (this.FormData.isGoTodo) {
          this.$router.push({
            path: '/my-business/business-management',
          })
          this.$emit('cancel')
        }
        this.$emit('refreshList')
        this.$emit('cancel')
      }
    },
    validatorDate(rule, value, callback) {
      if (!value) {
        callback(new Error('请输入隐患整改期限!'))
      }
      if (new Date() > new Date(value)) {
        callback(new Error('隐患整改期限必须大于当前时间!'))
        return
      }
      callback()
    },
    async getAcceptUsers() {
      const [err, res] = await hiddenDangerRectificationChecklistApi.getHiddenDangerExaminer()
      if (!err) {
        this.acceptUsers = res
      }
    },
    async getData() {
      this.formData = JSON.parse(JSON.stringify(this.FormData))
      if (this.formProps.editType === 'create') {
        this.formData.hiddenDangerCode = `SMDC${dayjs()
          .format('YYYY-MM-DD')
          .split('-')
          .join('')}-${Math.floor(Math.random() * 1000)}`
      }

      // 是否即查即改
      // const [err, res] = await hiddenDangerRectificationChecklistApi.getIsCheckCorrect()
      // if (!err) {
      //   this.isSelect = res
      //   if (this.formProps.editType === 'create') {
      //     this.$set(this.formData, 'isCheckCorrect', res)
      //   }
      // }
      this.$nextTick(() => {
        this.$refs.form.clearValidate()
      })
    },
    changePersonSelect(key) {
      this.$refs[key].$emit('el.form.change')
    },
    // 获取区域列表
    async getAreaList() {
      const [err, res] = await areaApi.getList({
        skipCount: 0,
        maxResultCount: 999,
      })
      if (!err) {
        this.areaList = res.items || []
      }
    },
    validatorPerson(rule, value, callback) {
      if (!value) {
        callback(new Error('该字段必须填写!'))
      }
      if (
        this.formData.personChargeHiddenDangerRectificationId ===
        this.formData.personChargeHiddenDangerAcceptanceId
      ) {
        callback(new Error('隐患整改负责人和隐患验收负责人不能是同一人!'))
        return
      }
      callback()
    },
    cancel() {
      // 待办新增过来回待办
      if (this.FormData.isGoTodo) {
        this.$router.push({
          path: '/my-business/business-management',
        })
      }
      this.$emit('cancel')
    },
    async submitForm(type) {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.loading = true
          // this.formData = utils.dealTimeField(this.formData)
          if (this.formData.creationTime) {
            this.formData.creationTime = dayjs(this.formData.creationTime).format(
              'YYYY-MM-DD HH:mm:ss'
            )
          }
          if (this.formData.hiddenDangerRectificationPeriod) {
            this.formData.hiddenDangerRectificationPeriod = dayjs(
              this.formData.hiddenDangerRectificationPeriod
            ).format('YYYY-MM-DD HH:mm:ss')
          }
          if (this.formProps.editType === 'create') {
            if (this.formData.id) {
              this.formData.hiddenDangerInvestigationTasksDetailId = this.formData.id
              delete this.formData.id
            }
            // 去除从排查那边多余数据提交，排查过来的多余的数据提交回造成接口提交成功但是数据库没有插入数据，暂时没有排查出是什么字段
            const [
              err,
              res,
            ] = await hiddenDangerRectificationChecklistApi.hiddenDangersReporteCreate({
              body: {
                hiddenDangerBelong: this.formData.hiddenDangerBelong,
                hiddenDangerName: this.formData.hiddenDangerName,
                hiddenDangerCode: this.formData.hiddenDangerCode,
                areaId: this.formData.areaId,
                hiddenDangerCategory: this.formData.hiddenDangerCategory,
                hiddenDangerType: this.formData.hiddenDangerType,
                hiddenDangerSource: this.formData.hiddenDangerSource,
                belongRiskPointId: this.formData.belongRiskPointId,
                hiddenDangerHarm: this.formData.hiddenDangerHarm,
                ownedSystemOrUnit: this.formData.ownedSystemOrUnit,
                hiddenDangerlevel: this.formData.hiddenDangerlevel,
                descriptionHazard: this.formData.descriptionHazard,
                safetyInspectionTitle: this.formData.safetyInspectionTitle,
                safetyInspectionPeriods: this.formData.safetyInspectionPeriods,
                suggestedRectificationMeasures: this.formData.suggestedRectificationMeasures,
                photosBeforeRectification: this.formData.photosBeforeRectification,
                isCheckCorrect: this.formData.isCheckCorrect,
                hiddenDangerRectificationPeriod: this.formData.hiddenDangerRectificationPeriod,
                personChargeHiddenDangerRectificationId: this.formData
                  .personChargeHiddenDangerRectificationId,
                personChargeHiddenDangerAcceptanceId: this.formData
                  .personChargeHiddenDangerAcceptanceId,
              },
            })
            if (!err) {
              if (type === 'submit') {
                this.currentSubmitRes = res
                this.selectUserVisible = true
                return
              }
              if (this.FormData.isGoTodo) {
                // 待办新增过来回待办
                this.$router.push({
                  path: '/my-business/business-management',
                })
                this.$emit('cancel')
                return
              }
              this.$emit('refreshList')
              this.$emit('cancel')
              this.$message({
                showClose: true,
                message: '新增成功',
                type: 'success',
              })
            }
          } else {
            const [
              err,
              res,
            ] = await hiddenDangerRectificationChecklistApi.hiddenDangersReporteUpdate({
              id: this.formData.id,
              body: this.formData,
            })
            if (!err) {
              if (type === 'submit') {
                if (this.FormData.hazardVerificationStatus === 2) {
                  const resData = await this.$confirm(
                    '该流程数据已被驳回，请检查驳回原因，确认无误后再提交',
                    '提示',
                    {
                      confirmButtonText: '确定',
                      cancelButtonText: '取消',
                      type: 'warning',
                    }
                  ).catch(() => {})
                  if (!resData) {
                    this.loading = false
                    return
                  }
                }
                this.currentSubmitRes = this.formData
                this.selectUserVisible = true
                return
              }
              this.$emit('refreshList')
              this.$emit('cancel')
              this.$message({
                showClose: true,
                message: '编辑成功',
                type: 'success',
              })
            }
          }
          this.loading = false
        }
      })
    },
  },
}
</script>

<style lang="scss">
.third-frame-style .el-dialog__body .avatar-upload {
  width: 120px !important;
}
</style>
